import { BlogArticlePage } from "@/components/blog/blog-pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/government/blog/$slug")({
  component: GovernmentBlogArticle,
});

function GovernmentBlogArticle() {
  const { slug } = Route.useParams();
  return (
    <BlogArticlePage
      portal="government"
      basePath="/government/blog"
      slug={slug}
    />
  );
}
